export default __webpack_public_path__ + "static/media/myImg.32a97e7b.jpg";